import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ACCOUNT_LOGIN_ROUTE,
  CHANGE_PASSWORD_ROUTE,
  DEFAULT_ROUTE_CONSTANT,
  DESTINATION_KEY_CONSTANT,
  LOGIN_OBJECT_KEY_CONSTANT,
  PRODUCT_KEY_CONSTANT,
} from '../constants/routes.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { UserProfileService } from '../services/user-profile.service';
import { MatStepper } from '@angular/material/stepper';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent {
  public form!: FormGroup;
  public inProgress: boolean = false;
  private productName!: string;
  private destination!: string;
  private loginObject!: string;
  private productNameKey: string = PRODUCT_KEY_CONSTANT;
  private destinationKey: string = DESTINATION_KEY_CONSTANT;
  private loginObjectKey: string = LOGIN_OBJECT_KEY_CONSTANT;
  public queryParams: { [key: string]: string } = {
    [this.productNameKey]: this.productName,
    [this.destinationKey]: this.destination,
    [this.loginObjectKey]: this.loginObject,
  };
  public loginRoute: string = ACCOUNT_LOGIN_ROUTE;
  public email!: string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly snackBar: MatSnackBar,
    private readonly userProfileService: UserProfileService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.initializeForm();

    this.productName = this.activatedRoute.snapshot.queryParamMap.get(
      this.productNameKey
    )!;
    this.destination = this.activatedRoute.snapshot.queryParamMap.get(
      this.destinationKey
    )!;
    this.loginObject = this.activatedRoute.snapshot.queryParamMap.get(
      this.loginObjectKey
    )!;

    this.queryParams = {
      [this.productNameKey]: this.productName,
      [this.destinationKey]: this.destination,
      [this.loginObjectKey]: this.loginObject,
    };

    if (!this.productName || !this.destination) {
      this.router.navigate(DEFAULT_ROUTE_CONSTANT, {
        queryParams: this.queryParams,
      });
    }
  }

  public get getLoginRoute() {
    return ['/', ...this.loginRoute.split('/')];
  }

  public initializePasswordReset(stepper?: MatStepper) {
    const data = this.form.getRawValue();

    this.inProgress = true;
    this.email = data.email;

    this.userProfileService
      .sendPasswordResetEmail(this.email, this.productName, this.destination)
      .subscribe({
        next: () => {
          this.inProgress = false;
          this.snackBar.open('Sent!', 'close', {
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: [
              'bg-primary',
              'text-white',
              'rounded-3e',
              'modified-snackbar',
            ],
          });
          this.form.reset();

          if (stepper) {
            stepper.next();
          } else {
            this.router.navigate(DEFAULT_ROUTE_CONSTANT, {
              queryParams: this.queryParams,
            });
          }
        },
        error: () => {
          this.inProgress = false;
          this.snackBar.open('An error occurred!', 'close', {
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: [
              'bg-danger',
              'text-white',
              'rounded-3e',
              'modified-snackbar',
            ],
          });
        },
      });
  }

  public initializeForm() {
    this.form = this.formBuilder.nonNullable.group({
      email: new FormControl(null, [Validators.required, Validators.email]),
    });
  }

  public goToChangePasswordScreen() {
    const paths = [...CHANGE_PASSWORD_ROUTE.split('/'), btoa(this.email)];

    this.router.navigate(paths, {
      queryParams: this.queryParams,
      queryParamsHandling: 'preserve',
    });
  }
}
